import React from 'react';

import {Collections} from "components";
import Framework from "@beardeddevops/react.framework";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'Invoices',
		url: '/invoices',
		icon: 'file-text-o',
	}
];

export default class Invoices extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<Collections.Invoices
					history={this.props.history}
					reloadParent={this.props.reloadParent}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>
			</div>
		);
	}
}
